import {useSelector, useDispatch} from 'react-redux';
import Selector from '../../../selectors/modules/module_modals';
import {closeModuleModal} from '../../../reducers/modules/actions';
import { AnimatePresence, motion } from 'framer-motion';

import ComebackReward from './comeback-reward';
import CashoutSuccess from './cashout-success';
import FacebookPost from './facebook-post';
import FacebookStory from './facebook-story';

export const ModalContainer = ({children}) => {
    return (
        <div className="modules-modal-container">
            {children}
        </div>
    )
}

export const ModalOverlay = () => {
    const dispatch = useDispatch();

    return (
        <motion.div
            className="modules-modal-overlay"
            onClick={() => dispatch(closeModuleModal())}
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 0.2 }}
        />
    )
}

export const Modal = ({
    children
}) => {
    return (
        <ModalContainer>
            <ModalOverlay />

            <motion.div
                className="modules-modal"
                initial={{
                    opacity: 0,
                    y: 40
                }}
                animate={{
                    opacity: 1,
                    y: 0
                }}
                exit={{
                    opacity: 0,
                    y: 40
                }}
                transition={{
                    duration: 0.25,
                    ease: 'easeOut'
                }}
            >
                {children}
            </motion.div>
        </ModalContainer>
    )
}

export default () => {
    const {modal, data} = useSelector(Selector);

    return (
        <AnimatePresence mode="wait">
            {modal?.key === 'modules_comeback_reward' && <ComebackReward modal={modal} data={data} />}
            {modal?.key === 'modules_cashout_success' && <CashoutSuccess modal={modal} data={data} />}
            {modal?.key === 'modules_facebook_post' && <FacebookPost modal={modal} data={data} />}
            {modal?.key === 'modules_facebook_story' && <FacebookStory modal={modal} data={data} />}
        </AnimatePresence>
    )
}